import { render, staticRenderFns } from "./uploadFile.vue?vue&type=template&id=0cf341c9&scoped=true"
import script from "./uploadFile.vue?vue&type=script&lang=js"
export * from "./uploadFile.vue?vue&type=script&lang=js"
import style1 from "./uploadFile.vue?vue&type=style&index=1&id=0cf341c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf341c9",
  null
  
)

export default component.exports